
/* 유튜브 영역 클릭 */
$('.youtube-list li a').click(function(){
    var yid = $(this).data('youtube');
    var src = 'https://www.youtube.com/embed/'+yid+'?autoplay=1&amp;rel=0&amp;wmode=opaque&amp;showinfo=0';
    $('.js-youtube-player').attr('src',src);
    $('#popup_youtube').addClass('show');
});

$('#popup_youtube .btn-close').click(function(){
    $('#popup_youtube').removeClass('show');
    $('.js-youtube-player').attr('src','');
});


/* 유튜브 영역 모바일 슬라이드 */
var mo = $(window).width() < 751 ? true : false;

if(mo){
    var $ytbSlide = $('.youtube-list ul');

    $ytbSlide.slick({
        arrows: false,
        infinite: false,
        speed : 500,
        mobileFirst: true,
        slidesToShow: 1.95,
        slidesToScroll: 1
    }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $ytbLi = $(this).find('li').length;
        var pstL = $('.progress-bar').width();
        var lw = pstL / $ytbLi;
        var currentSlideIndex = nextSlide + 2;
        
        pstL = currentSlideIndex*lw;

        $(this).parent().next().find('span').css({
            width: pstL,
        });
    });
}

AOS.init({
    once:true,
    startEvent: 'load',
    duration: 1000,
});

//
var activeIdx,
    isMobile = false,
    // vdoFileName = ['03_Water', '02_Monogram', '01_Logo', '04_WB_essence', '08_Moisture', '07_Luminous', '06_Glow', '05_Holiday', '09_WSM', '10_WB', '11_Neo'],
    slides = $('.wrap-card-slide .swiper-slide'),
    vdeHtml = [],
    filter = "win16|win32|win64|mac",
    macOS = 'Mac OS',
    animationend = 'animationend webkitAnimationEnd',
    transitionEnd = 'transitionend webkitTransitionEnd oTransitionEnd otransitionend';

var writeHtml = function(i, url) {
    // for (var i = 0; i < vdoFileName.length; i++) {
    //     vdeHtml[i] = '<video muted loop playsinline height="100%"><source src="/int/en/assets/image/meets-arts/' + vdoFileName[i] + '.mp4" type="video/mp4"></video>'
    // }
    vdeHtml[i] = `<video muted loop playsinline height="100%"><source src="${url}" type="video/mp4"></video>`
};

var bgChange = function(idx) {
    $('.meets-intro').attr('data-active-idx', idx);
    $('.intro-bg span').each(function() {
        var bgIdx = Number($(this).attr('data-active-idx'));
        if (idx === bgIdx) {
            $(this).siblings().removeClass('on').end().addClass('on');
        };
    });
    textChange(idx);
};
var textChange = function(idx) {
    $('.meets-intro').attr('data-active-idx', idx);
    $('.wrap-slide-text li').each(function() {
        var bgIdx = Number($(this).attr('data-active-idx'));
        if (idx === bgIdx) {
            $(this).siblings().attr('aria-current', 'false').end().attr('aria-current', 'true');
            $(this).siblings().removeClass('on').end().addClass('on');
        };
    });
};
var cardSlide = new Swiper('.wrap-card-slide .swiper-container', {
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 30,
    initialSlide: 2,
    // loop: true,
    // loopAdditionalSlides: 5,
    // loopedSlides: 5,
    navigation: {
        nextEl: '.wrap-card-slide .swiper-button-next',
        prevEl: '.wrap-card-slide .swiper-button-prev',
    },
    pagination: {
        el: '.wrap-card-slide .swiper-pagination',
        type: 'bullets',
        clickable: true,
    },

    breakpoints: {
        960: {
            spaceBetween: 60
        },
    },
    on: {
        init: function() {
            var $thisSlide = this;
            $('.wrap-card-slide .swiper-slide').each(function(idx) {
                writeHtml(idx, $(this).data('video-url'));
                if (idx === $thisSlide.activeIndex) {
                    var $this = $(this).find('.wrap-vdo .inner-vdo');
                    $this.append(vdeHtml[$thisSlide.activeIndex]);
                    $this.find('video').get(0).play();
                }
            });
        },
        slideChange: function() {
            var $thisSlide = this;
            $('.wrap-card-slide .swiper-slide').each(function(idx) {
                if (idx === $thisSlide.activeIndex) {
                    var $this = $(this).find('.wrap-vdo .inner-vdo');
                    if ($(this).find('.wrap-vdo .inner-vdo video').length === 0) {
                        $this.append(vdeHtml[$thisSlide.activeIndex]);
                        if(vdeHtml[$thisSlide.activeIndex]) {
                            $(this).find('.wrap-vdo .inner-vdo video').get(0).play();
                        }
                    }
                }
            });
            bgChange(this.activeIndex);
        },
        slideChangeTransitionEnd: function() {
            $('.wrap-card-slide .swiper-slide').each(function(idx) {
                if ($(this).find('.wrap-vdo .inner-vdo video').length !== 0) {
                    var $this = $(this).find('.wrap-vdo .inner-vdo');
                    $this.find('.vdo-poster').off();
                    $this.find('.vdo-poster').on(transitionEnd, function() {
                        if (idx !== cardSlide.activeIndex) $this.find('video').remove();
                    });
                };
            });

        }
    }
});
$(function() {
    // 모바일 접속 구분
    if (navigator.platform) {
        if (navigator.userAgent.indexOf(macOS) > 0) $('body').addClass('mac');
        isMobile = filter.indexOf(navigator.platform.toLowerCase()) < 0;
        if (isMobile) $('body').addClass('mobile');
    };
});